
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.948 1.923h12.1a1.839 1.839 0 011.834 1.834v2.017a3.422 3.422 0 01-.917 2.109l-3.938 3.484a2.984 2.984 0 00-.913 2.109v3.947a2.042 2.042 0 01-.825 1.559l-1.284.825a1.869 1.869 0 01-2.847-1.564v-4.859a3.544 3.544 0 00-.734-1.926L3.939 7.791a3.039 3.039 0 01-.825-1.834V3.848a1.861 1.861 0 011.834-1.925z","fill":"none","stroke":"#717b8c","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M10.016 1.923L5.501 9.157","fill":"none","stroke":"#717b8c","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","opacity":".4"}})])
          )
        }
      }
    